import React from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';

export default function CreateListingSuccessControls({ listing, onClose }) {
  return <React.Fragment>
    <Button.Cancel onClick={onClose}>
      Close
    </Button.Cancel>

    <a className="ml-2" href={listing.path}>
      <Button.Primary>
        Edit Listing
      </Button.Primary>
    </a>
  </React.Fragment>;
}

CreateListingSuccessControls.propTypes = {
  listing: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};
